var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewWorkspaceModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Onlinebusinessconference"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M132.575 83.3544C132.473 83.4249 132.416 83.4646 132.416 83.4646L110.798 114.083C106.79 119.759 99.2575 121.161 93.5819 117.884C92.5323 117.28 91.5445 116.517 90.658 115.587L82.1953 107.208L95.7295 90.9395L100.082 95.1687L120.624 72.6558C120.624 72.6558 119.781 60.3828 123.821 59.9771C126.59 59.6992 126.939 67.0242 126.939 67.0242C126.939 67.0242 131.565 55.8493 134.365 57.4546C136.544 58.707 132.57 66.1643 131.838 67.4961C132.659 66.0937 137.615 57.8427 139.847 59.8934C141.655 61.5559 136.001 69.0704 134.802 70.6272C135.706 69.5159 139.08 65.5866 140.544 66.8346C142.488 68.4884 135.935 74.6668 135.697 74.8917C135.895 74.7284 139.953 71.4739 141.033 73.3129C142.687 76.1221 133.867 82.4459 132.575 83.3544Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M132.579 83.3499C132.477 83.4205 132.42 83.4602 132.42 83.4602L110.802 114.079C106.794 119.754 99.2616 121.157 93.5859 117.88C99.6849 115.962 105.497 112.425 110.458 108.165C112.924 106.044 115.226 103.742 117.395 101.334C121.223 97.087 124.645 92.5139 127.984 87.9055C128.866 86.6927 129.77 84.104 131.256 83.5395C131.772 83.3455 132.208 83.2927 132.579 83.3499Z",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M132.415 83.4657L110.796 114.085C106.049 120.808 96.3465 121.532 90.6545 115.586L82.1953 107.207L95.7254 90.9381L100.081 95.1698L120.623 72.6544C120.623 72.6544 119.778 60.381 123.82 59.9758C126.587 59.6985 126.938 67.0251 126.938 67.0251C126.938 67.0251 131.563 55.8476 134.362 57.455C136.757 58.8306 131.722 67.7002 131.722 67.7002C131.722 67.7002 137.408 57.6534 139.845 59.8931C141.866 61.751 134.574 70.9105 134.574 70.9105C134.574 70.9105 138.843 65.3894 140.542 66.8351C142.523 68.5203 135.686 74.8961 135.686 74.8961C135.686 74.8961 139.924 71.4247 141.031 73.3103C142.811 76.3429 132.415 83.4657 132.415 83.4657Z",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M55.4844 83.3417L76.6393 107.365C78.1689 109.788 81.6087 110.035 83.4688 107.855L96.5485 92.5273C98.0157 90.808 97.8812 88.2412 96.2423 86.6847L78.3354 69.6763C76.9498 68.3603 75.1147 67.6218 73.2038 67.6111L64.1074 67.5938",
    fill: "#FFB35F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M74.7451 83.4676C74.7451 83.292 55.776 82.8047 55.776 82.8047L55.4844 83.3372L76.639 107.363C78.1693 109.784 81.609 110.031 83.47 107.852L89.6352 100.629C84.7092 96.4789 74.7451 90.4089 74.7451 83.4676Z",
    fill: "#D88223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M96.5578 92.5219L83.4734 107.851C82.3048 109.222 80.5144 109.633 78.962 109.148L79.4295 111.988L73.3438 108.707L93.5899 84.1562L96.2491 86.6832C97.8896 88.2355 98.0219 90.8064 96.5578 92.5219Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M55.4922 83.3359L76.6468 107.364C77.2119 108.265 78.0457 108.863 78.9634 109.149",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M81.5816 125.132L72.1377 67.6031L29.4792 67.3984L23.8203 125.132H81.5816Z",
    fill: "#FFB35F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M79.7034 113.675H79.699C75.1435 115.735 70.0897 116.881 64.7669 116.881C44.7235 116.881 28.4772 100.631 28.4772 80.5873C28.4772 79.8754 28.5046 79.1703 28.5451 78.4688H28.3976L23.8203 125.137H81.5821L79.7034 113.675Z",
    fill: "#D88223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M96.5495 92.522L83.4651 107.851C82.2965 109.223 80.5061 109.633 78.9537 109.148L79.4212 111.988L81.5821 125.129H23.8203L29.4827 67.3984L64.1098 67.588L72.1403 67.6013L73.2032 67.6057C75.1127 67.6189 76.9472 68.3554 78.3364 69.6695L93.5816 84.1563L96.2408 86.6832C97.8813 88.2355 98.0137 90.8065 96.5495 92.522Z",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M64.4443 125.889L58.8216 139.67L42.981 134.334L25.1338 128.328C16.8034 125.523 11.8378 116.985 13.5224 108.359L14.519 103.266L16.8784 103.354L36.0309 104.055L35.118 109.704L64.4443 125.889Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M42.981 134.334L25.1338 128.328C16.8034 125.523 11.8378 116.985 13.5224 108.359L14.519 103.266L16.8784 103.354C16.53 104.518 16.5432 105.775 16.799 106.961C17.1871 108.743 18.0911 110.366 19.0569 111.909C24.3577 120.385 31.9296 127.419 40.7672 132.085C41.3713 132.402 41.9931 132.72 42.4474 133.227C42.7252 133.536 42.9237 133.933 42.981 134.334Z",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M14.517 103.266L13.5222 108.361C11.8383 116.987 16.8029 125.526 25.1321 128.33L58.8232 139.673L64.4441 125.89L35.1191 109.705L36.0304 104.055L14.517 103.266Z",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M29.8153 67.3984C21.0892 67.3984 13.7755 73.9954 12.8787 82.6754L11.1701 99.2126C10.9303 101.522 12.7134 103.544 15.0344 103.595L36.0312 104.055C38.1285 104.101 39.9001 102.509 40.077 100.418L41.3098 85.8433L29.8153 67.3984Z",
    fill: "#FFB35F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M40.2535 98.3458L40.0772 100.418C39.9007 102.509 38.1323 104.101 36.0332 104.057L15.0373 103.594C12.7133 103.545 10.9317 101.521 11.1698 99.2145L12.8809 82.6771C13.1058 80.4898 13.7408 78.4303 14.7022 76.5781C14.9624 88.7629 24.9289 98.5574 37.1754 98.5574C38.2205 98.5574 39.2481 98.4869 40.2535 98.3458Z",
    fill: "#D88223"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M41.3119 85.8409L40.4608 95.8648L40.0772 100.416C39.9008 102.506 38.1324 104.098 36.0332 104.054L15.0374 103.591C12.7133 103.543 10.9317 101.518 11.1698 99.212L11.5182 95.8648L12.8809 82.6746C13.7761 73.9913 21.0922 67.3984 29.8152 67.3984",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M78.9628 109.149L74.6406 82.8047",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M135.729 95.0625L126.824 139.675H63.1016L72.0066 95.0625H135.729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.6,
    d: "M127.781 134.871L126.823 139.677H63.1016L72.0039 95.0625H73.7706C73.5871 96.5654 73.4953 98.1026 73.4953 99.6571C73.4953 120.955 90.7607 138.215 112.059 138.215C117.657 138.215 122.98 137.022 127.781 134.871Z",
    fill: "#FFF0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M135.729 95.0625L126.824 139.675H63.1016L72.0066 95.0625H135.729Z",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M72.0101 95.0547L63.0989 139.67H35.6953V135.089H59.9171L67.919 95.0547H72.0101Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    opacity: 0.6,
    d: "M95.4255 116.874C94.5627 119.393 95.9053 121.435 98.4246 121.435C100.944 121.435 103.685 119.393 104.548 116.874C105.411 114.354 104.068 112.312 101.549 112.312C99.0296 112.312 96.2883 114.354 95.4255 116.874Z",
    fill: "#FFF0CF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_23"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.0237 50.5815C63.989 51.322 65.3701 51.1401 66.1106 50.1749C66.8511 49.2097 66.6692 47.8286 65.7039 47.088C64.7388 46.3476 63.3577 46.5295 62.6172 47.4948",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.0237 50.5815C63.989 51.322 65.3701 51.1401 66.1106 50.1749C66.8511 49.2097 66.6692 47.8286 65.7039 47.088C64.7388 46.3476 63.3577 46.5295 62.6172 47.4948",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M35.3022 46.228C34.9843 47.7123 34.8992 49.1898 35.0235 50.625C35.5699 56.9772 40.1843 62.5046 46.7456 63.9101C54.7863 65.6325 62.7054 60.5075 64.4277 52.4668C65.252 48.6185 64.5036 44.7931 62.614 41.6638C60.5724 38.2605 57.1768 35.6826 52.9844 34.7845C52.7731 34.7393 52.5557 34.698 52.3472 34.6636C51.4246 34.5071 50.5038 34.4384 49.6005 34.4557C42.8273 34.5673 36.7814 39.3225 35.3022 46.228Z",
    fill: "#FFE4AA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M35.3062 46.2306C34.9892 47.7104 34.9078 49.1934 35.0321 50.6261C35.5789 56.9814 40.1907 62.5061 46.754 63.912C52.5605 65.1558 58.3057 62.8244 61.6967 58.4112C58.3032 61.2642 53.6753 62.571 49.0042 61.5704C42.4409 60.1645 37.8292 54.6396 37.2824 48.2843C37.158 46.8517 37.2438 45.3754 37.562 43.89C38.0423 41.6477 39.0056 39.6328 40.3215 37.9297C37.8498 39.9819 36.0309 42.8473 35.3062 46.2306Z",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M35.3022 46.228C34.9843 47.7123 34.8992 49.1898 35.0235 50.625C35.5699 56.9772 40.1843 62.5046 46.7456 63.9101C54.7863 65.6325 62.7054 60.5075 64.4277 52.4668C65.252 48.6185 64.5036 44.7931 62.614 41.6638C60.5724 38.2605 57.1768 35.6826 52.9844 34.7845C52.7731 34.7393 52.5557 34.698 52.3472 34.6636C51.4246 34.5071 50.5038 34.4384 49.6005 34.4557C42.8273 34.5673 36.7814 39.3225 35.3022 46.228Z",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M35.3022 46.228C34.9843 47.7123 34.8992 49.1898 35.0235 50.625C42.7809 51.9423 50.272 46.9671 52.0246 39.2414C52.0422 39.1834 52.0558 39.1196 52.0685 39.0606C52.3864 37.5763 52.4716 36.0988 52.3472 34.6636C51.4246 34.5071 50.5038 34.4384 49.6005 34.4557C42.8273 34.5673 36.7814 39.3225 35.3022 46.228Z",
    fill: "#5D4B37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M49.6016 34.4557C49.9408 36.2555 50.7926 37.9183 52.0257 39.2414C53.3285 40.6462 55.0604 41.6803 57.0755 42.1119C58.9972 42.5236 60.9093 42.3318 62.6151 41.6638C60.5735 38.2605 57.1778 35.6826 52.9855 34.7845C52.7741 34.7393 52.5568 34.698 52.3483 34.6636C51.4257 34.5071 50.5048 34.4384 49.6016 34.4557Z",
    fill: "#5D4B37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M59.2679 48.5615C58.1462 48.1782 57.1929 48.4506 56.408 49.3784M47.91 49.5188C47.4058 51.8726 48.9074 54.1929 51.2614 54.6972C53.6153 55.2014 55.9356 53.6998 56.4398 51.3459C56.945 48.9874 55.4434 46.6672 53.0894 46.1629C50.7354 45.6587 48.4152 47.1603 47.91 49.5188ZM59.3521 47.3205C58.8478 49.6744 60.3494 51.9947 62.7034 52.4989C65.0574 53.0031 67.3777 51.5015 67.8819 49.1476C68.3871 46.7892 66.8855 44.4689 64.5315 43.9647C62.1775 43.4604 59.8572 44.962 59.3521 47.3205Z",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M47.9162 49.517L40.1719 49.0469",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M67.5095 46.2636L64.2734 45.5703",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M54.487 50.291C54.6632 51.0341 54.2034 51.7798 53.4602 51.956L52.6717 52.143C52.6445 52.1494 52.6172 52.1559 52.589 52.1579C51.8724 52.2848 51.1763 51.8323 51.0065 51.1163C50.9184 50.7445 50.9884 50.3738 51.1751 50.0711C51.3618 49.7683 51.6617 49.5392 52.0334 49.451L52.8219 49.2641C53.4292 49.1201 54.0369 49.4021 54.3402 49.914C54.4055 50.028 54.4548 50.1549 54.487 50.291Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M54.4926 50.2911C54.6687 51.0341 54.2089 51.7798 53.4657 51.9561L52.6772 52.143C52.65 52.1495 52.6227 52.1559 52.5945 52.158C52.3669 51.1779 52.9765 50.1957 53.9554 49.9636C54.0868 49.9325 54.2169 49.9161 54.3457 49.9141C54.411 50.0281 54.4603 50.155 54.4926 50.2911Z",
    fill: "#5D4B37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M64.7292 47.8691C64.9054 48.6122 64.4456 49.3579 63.7024 49.5341L62.9139 49.7211C62.8866 49.7275 62.8594 49.734 62.8312 49.736C62.1146 49.8629 61.4185 49.4105 61.2487 48.6944C61.1606 48.3226 61.2306 47.9519 61.4173 47.6492C61.604 47.3464 61.9039 47.1173 62.2756 47.0292L63.0641 46.8422C63.6714 46.6982 64.2791 46.9802 64.5824 47.4921C64.6477 47.6061 64.697 47.733 64.7292 47.8691Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M64.7269 47.8692C64.9031 48.6123 64.4433 49.358 63.7001 49.5342L62.9115 49.7212C62.8843 49.7276 62.8571 49.7341 62.8289 49.7361C62.6013 48.7561 63.2109 47.7738 64.1898 47.5417C64.3212 47.5106 64.4513 47.4942 64.5801 47.4922C64.6454 47.6062 64.6947 47.7331 64.7269 47.8692Z",
    fill: "#5D4B37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M59.9945 56.0138C58.855 57.0488 57.7943 56.9901 56.8125 55.8359",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M39.7444 39.5435C44.0992 39.5435 47.6294 36.0132 47.6294 31.6585C47.6294 27.3037 44.0992 23.7734 39.7444 23.7734C35.3896 23.7734 31.8594 27.3037 31.8594 31.6585C31.8594 36.0132 35.3896 39.5435 39.7444 39.5435Z",
    fill: "#5D4B37"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M40.6163 37.4297C38.2812 39.6103 35.1109 40.8733 31.916 40.8957C30.8482 40.9032 29.782 40.7779 28.7145 40.803C27.6469 40.8281 26.5504 41.0167 25.6516 41.5933C24.7528 42.1698 24.0889 43.1953 24.1709 44.2601C24.2392 45.1473 24.8109 45.9414 25.5424 46.4482C27.1143 47.5371 29.2932 47.3743 31.012 46.5361C32.7307 45.698 34.0917 44.2888 35.4145 42.9078C36.9001 41.357 38.3857 39.8062 39.8713 38.2554M44.5234 36.5432C46.8585 34.3626 50.0288 33.0996 53.2237 33.0772C54.2915 33.0697 55.3577 33.195 56.4253 33.1699C57.4928 33.1448 58.5893 32.9562 59.4881 32.3796C60.3869 31.8031 61.0508 30.7775 60.9688 29.7129C60.9005 28.8256 60.3289 28.0315 59.5974 27.5247C58.0255 26.4358 55.8466 26.5986 54.1278 27.4368C52.409 28.2749 51.048 29.6841 49.7252 31.065C48.2396 32.6159 46.754 34.1667 45.2684 35.7175",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.1696 53.7044C36.5596 54.757 35.2134 55.1154 34.1609 54.5055C33.1083 53.8955 32.7499 52.5493 33.3599 51.4967C33.9698 50.4442 35.316 50.0858 36.3686 50.6958",
    fill: "#F9D891"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.1696 53.7044C36.5596 54.757 35.2134 55.1154 34.1609 54.5055C33.1083 53.8955 32.7499 52.5493 33.3599 51.4967C33.9698 50.4442 35.316 50.0858 36.3686 50.6958",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M126.943 67.0234C126.943 67.0234 128.377 70.3026 125.836 72.2081",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M26.2344 139.672H134.012",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M82.1599 41.1463L80.3342 47.3161L86.6319 45.3323C89.4307 47.1655 92.7753 48.2327 96.3703 48.2327C106.197 48.2327 114.162 40.2655 114.162 30.4406C114.162 20.6138 106.197 12.6484 96.3703 12.6484C86.5454 12.6484 78.5781 20.6138 78.5781 30.4406C78.5781 34.459 79.9107 38.1669 82.1599 41.1463Z",
    fill: "#FCE8BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M88.4219 27.3281H103.732",
    stroke: "#FFD57B",
    strokeWidth: 1.76399,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M88.4219 33.1328H97.7745",
    stroke: "#FFD57B",
    strokeWidth: 1.76399,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M40.4608 95.8672L40.0772 100.418C39.9007 102.509 38.1323 104.101 36.0332 104.057L15.0373 103.593C12.7133 103.545 10.9317 101.521 11.1698 99.2144L11.5182 95.8672H40.4608Z",
    fill: "white",
    stroke: "#312314",
    strokeWidth: 0.440997,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewWorkspaceModalIcon);
export default __webpack_public_path__ + "static/media/newWorkspaceModalIcon.716503c50fbd1e72bb08903eee0316a4.svg";
export { ForwardRef as ReactComponent };